<template>
  <div class="bg-white py-6" :style="isAssignPage ? { paddingTop: '8px' } : { paddingTop: '24px' }">
    <header class="pl-5 pr-4 border-l-4 border-solid border-theme text-medium-x text-theme-black-850 font-semibold">
      App 下载
    </header>
    <div class="px-3 pt-3 pb-8">
      <InvestigatorAppQRCode/>
    </div>
    <header class="pl-5 pr-4 border-l-4 border-solid border-theme text-medium-x text-theme-black-850 font-semibold">
      线上结算
    </header>
    <div class="px-3 pt-3" v-if="!isOpen">
      <div class="text-medium text-theme-black-650 mb-3 leading-24">
        <span v-custom="'out_D74'">调研工厂</span>已开通线上结算服务，助您一键结算面对面访问、电话调查、明察暗访的调查员、代理费用。
      </div>
      <div class="text-medium text-theme-black-650 mb-3 leading-24">
        开通线上结算服务后，您可使用线上结算，<span v-custom="'out_D74'">调研工厂</span>将按调查员到手金额的 {{getAccountingRateVal('6.5%～7.5%【具体服务费费率请与客服联系】')}}  收取费用，用于调查员代缴税及平台技术服务费。同时，为您的总花费金额开具 6% 的增值税专用发票或普通发票。
      </div>
      <div class="text-center mb-3">
        <!-- <img src="/assets/img/settlement/protocol-intro.png" alt="" style="width: 188px" /> -->
        <el-image style="width: 100%" :src="url" :preview-src-list="srcList"> </el-image>
      </div>
      <div class="text-medium text-theme-black-650 mb-3 leading-24">
        如您对线上结算服务感兴趣，或有任何疑问，请微信扫码联系客服
      </div>
      <ContactInformation class="text-medium text-theme-black-850"></ContactInformation>
    </div>
    <div class="px-3 pt-3" v-else>
      <div class="text-medium text-theme-black-650 mb-3 leading-24">
        <span v-custom="'out_D74'">调研工厂</span>助您一键结算面对面访问、电话调查、明察暗访的调查员、代理费用。
      </div>
      <div class="text-medium text-theme-black-650 mb-3 leading-24">
        您可使用线上结算，<span v-custom="'out_D74'">调研工厂</span>将按调查员到手金额的 {{getAccountingRateVal()}} 收取费用，用于调查员代缴税及平台技术服务费。同时，为您的总花费金额开具 6% 的增值税专用发票或普通发票。
      </div>
      <div class="text-center mb-3">
        <el-image style="width: 100%" :src="url" :preview-src-list="srcList"> </el-image>
      </div>
    </div>

    <div class="right-counter">
      <account-calculator :title="'线上结算费用计算器'" :content="isOpen?content2:content1" :ratio="accountingRate"/>
    </div>
  </div>
</template>
<script>
import AccountCalculator from '@/components/base/AccountCalculator.vue'
import ContactInformation from '@/components/base/ContactInformation'
import { mapGetters } from 'vuex'
import InvestigatorAppQRCode from '@/layout/components/InvestigatorAppQRCode.vue'
export default {
  props: ['settlementVisible', 'isAssignPage'],
  components: { AccountCalculator, ContactInformation, InvestigatorAppQRCode },
  data() {
    return {
      url:'/assets/img/settlement/protocol-intro.png',
      srcList: ['/assets/img/settlement/protocol-intro.png']
    }
  },
  watch: {
    settlementVisible: function (val) {
      if (val === true) {
        console.log(123)
        this.btnChecked = 'online'
        this.baseInfo = {
          settleMethod: 0,
          settleMode: 1,
          settleRule: {
            unitPriceYuan: undefined, //单价 多少元/天  多少元/份
            expectedQuantity: undefined, // 数量 多少份 | 多少天
            tiers: [
              {
                quantityLowerBound: 0,
                quantityUpperBound: undefined,
                unitPriceYuan: undefined
              }
            ]
          }
        }
      }
    }
  },
  computed: {
    ...mapGetters(['configContextMap']),
    accountingRate(){
      return this.$store.getters.accountingRate?.valueOf()
    },
    isOpen() {
      return this.$store.getters.settlementType !== 1
    },
    content1() {
      return '若使用线上结算，调研工厂工厂将按调查员到手金额的 6.5%-7.5% 收取服务费，用于调查员代缴税及平台技术服务费。您可使用下方计算器计算调查员到手金额或调查费用预算（以 6.5% 为例）'
    },
    content2() {
      return `若使用线上结算，调研工厂工厂将按调查员到手金额的 ${this.getAccountingRateVal()} 收取服务费，用于调查员代缴税及平台技术服务费。您可使用下方计算器计算调查员到手金额或调查费用预算。`
    }
  },
  methods: {
    getAccountingRateVal(defaultVal = '6.5%') {
      const { accountingRate = 0 } = this.$store.getters || {};
      return accountingRate === null || accountingRate === 0 ? defaultVal : `${accountingRate}%`
    }
  },
  mounted() {
    
  }
}
</script>
<style lang="scss" scoped></style>
